import { createSelector } from '@ngrx/store';
import { TPlani8State } from '../reducers';
import { TFactoryListState } from './factory-list.models';

export const getFactoryListState = (state: TPlani8State) => state.factoryListInfo;

export const getFactoryListInfo = createSelector(
  getFactoryListState,
  (state: TFactoryListState) => state.factoryListingInfo,
);

export const getFactoryUom = createSelector(getFactoryListState, (state: TFactoryListState) => state.factoryUom);
